module.exports = __webpack_public_path__ + "img/casa_los chicos no lloran.c14d1241.webp";